import { render, staticRenderFns } from "./CourseShare.vue?vue&type=template&id=bd32c4ca&scoped=true&"
import script from "./CourseShare.vue?vue&type=script&lang=js&"
export * from "./CourseShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd32c4ca",
  null
  
)

export default component.exports